/**
 * Simple event bus for component communication
 */
type EventCallback = (data?: any) => void;

class EventBus {
  private events: { [key: string]: EventCallback[] } = {};

  /**
   * Subscribe to an event
   */
  on(event: string, callback: EventCallback): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  /**
   * Unsubscribe from an event
   */
  off(event: string, callback: EventCallback): void {
    if (!this.events[event]) return;

    const index = this.events[event].indexOf(callback);
    if (index > -1) {
      this.events[event].splice(index, 1);
    }
  }

  /**
   * Emit an event
   */
  emit(event: string, data?: any): void {
    if (!this.events[event]) return;

    this.events[event].forEach((callback) => {
      try {
        callback(data);
      } catch (error) {
        console.error(`Error in event callback for ${event}:`, error);
      }
    });
  }

  /**
   * Remove all listeners for an event
   */
  removeAllListeners(event: string): void {
    delete this.events[event];
  }
}

// Create a singleton instance
export const eventBus = new EventBus();

// Event types
export const EVENTS = {
  FILTERS_CHANGED: "filters_changed",
  PAGE_CHANGED: "page_changed",
  SORT_CHANGED: "sort_changed",
  ITEMS_PER_PAGE_CHANGED: "items_per_page_changed",
  FACETS_LOADED: "facets_loaded",
  FILTER_REMOVED: "filter_removed",
  FILTER_TOGGLED: "filter_toggled",
} as const;
